import React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { RootState } from '@Redux/search/store';
import Pc from './subComponent/Pc';
import M from './subComponent/M';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './styles.module.scss';

declare global {
    interface Window {
        CancelFavorite: any;
    }
}

const ResultCards = () => {
    const { SwitchListBy } = useSelector((state: RootState) => state.search);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const isCards: boolean = SwitchListBy === 'List';

    return (
        <div className={cN('ResultCards', styles.ResultCards, { [`${styles.show}`]: isCards })}>
            {isMobile ? (
                <M/>
            ) : (
                <Pc/>
            )}
        </div>
    );
};

export default ResultCards;
